import { Injectable, signal } from '@angular/core';
import { ResolveEnd, ResolveStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ResolverStatusService {
    private resolvingSignal = signal(false);
    readonly resolving = this.resolvingSignal.asReadonly();

    constructor(private router: Router) {
        router.events.subscribe(event => {
            if (event instanceof ResolveStart) {
                this.resolvingSignal.set(true);
            }
            if (event instanceof ResolveEnd) {
                this.resolvingSignal.set(false);
            }
        });
    }
}